import React from "react";
import { IoIosWarning } from "react-icons/io";
import { useTranslation } from "../context/TranslationContext";
import { translateAlertMessage } from "../helpers/clientDisplayHelper";
import { highestAlertLevel, normalizeAlertLevel, sortAlertsByLevel } from "../helpers/partyAlertsHelper";

// `extraItems` ([{ id, level, content }]) lets a page add its own lines, e.g. missing documents.
const PartyAlertsBanner = ({ alerts, extraItems = [] }) => {
  const { t } = useTranslation();
  const list = Array.isArray(alerts) ? alerts : [];
  const extras = Array.isArray(extraItems) ? extraItems : [];
  if (list.length === 0 && extras.length === 0) return null;

  const level = highestAlertLevel([...list, ...extras]).toLowerCase();

  return (
    <section
      className={`portal-page-panel party-alerts-banner is-${level}`}
      aria-labelledby="party-alerts-title"
      data-testid="party-alerts-banner"
      data-level={level}
    >
      <IoIosWarning className="party-alerts-icon" aria-hidden="true" />
      <div className="party-alerts-body">
        <h3 id="party-alerts-title" className="party-alerts-title">{t("clientDetails.party.alerts.title")}</h3>
        <ul className="party-alerts-list">
          {sortAlertsByLevel(list).map((alert, index) => {
            const alertLevel = normalizeAlertLevel(alert.level).toLowerCase();
            return (
              <li key={`${alert.message}-${index}`} className={`party-alerts-item is-${alertLevel}`}>
                <span className="party-alerts-dot" aria-hidden="true" />
                <span className="sr-only">{t(`clientDetails.party.alerts.level.${alertLevel}`)}: </span>
                {translateAlertMessage(alert.message, t)}
              </li>
            );
          })}
          {extras.map((item) => {
            const itemLevel = normalizeAlertLevel(item.level).toLowerCase();
            return (
              <li key={item.id} className={`party-alerts-item is-${itemLevel}`} data-testid={`party-alerts-extra-${item.id}`}>
                <span className="party-alerts-dot" aria-hidden="true" />
                <span className="sr-only">{t(`clientDetails.party.alerts.level.${itemLevel}`)}: </span>
                {item.content}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default PartyAlertsBanner;
